import Auth from '@aws-amplify/auth';

export class SessionStorage {
  static setSelectedDomain(value: string) {
    window.sessionStorage.setItem('selectedDomain', value);
  }

  static getSelectedDomain() {
    return window.sessionStorage.getItem('selectedDomain');
  }

  static isValidDomain(value: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Auth.currentSession().then(session => {
        const currentUserTokenInfo = session.getIdToken().decodePayload();
        const domains = 'lambdaDomainIds';
        currentUserTokenInfo[domains] = JSON.parse(currentUserTokenInfo[domains]);
        resolve(currentUserTokenInfo[domains].some(domainId => domainId === value));
      });
    });
  }
}
